/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBaseForKubernetesClusterGcp extends models.ServiceAccountCredentialsBaseForKubernetesCluster {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsBaseForKubernetesClusterGcp");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsBaseForKubernetesClusterGcp.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBaseForKubernetesClusterGcp>): ServiceAccountCredentialsBaseForKubernetesClusterGcp {
        let obj = Object.assign(new ServiceAccountCredentialsBaseForKubernetesClusterGcp(), model);
        ServiceAccountCredentialsBaseForKubernetesClusterGcp.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBaseForKubernetesClusterGcp>): ServiceAccountCredentialsBaseForKubernetesClusterGcp {
        if (!model) return null;
        return ServiceAccountCredentialsBaseForKubernetesClusterGcp.newInstance(<ServiceAccountCredentialsBaseForKubernetesClusterGcp> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBaseForKubernetesClusterGcp) {
        if (!obj) return;

        models.ServiceAccountCredentialsBaseForKubernetesClusterGcp.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBaseForKubernetesClusterGcp): boolean {
        if (models.ServiceAccountCredentialsBaseForKubernetesCluster.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsBaseForKubernetesClusterGcp.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
